module.exports = __webpack_public_path__ + "img/组 7414@2x.05fad314.png";